var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie"},[_c('canvas',{ref:"background",staticClass:"pie-chart is-background",attrs:{"width":"512","height":"512"}}),_c('canvas',{ref:"foreground",staticClass:"pie-chart is-foreground",attrs:{"width":"512","height":"512"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }